"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixCare = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class MatrixCare {
    parse(pastedData, event, callbackEmit) {
        pastedData = pastedData.replace(/\r\n/g, "\n");
        try {
            const patientInfo = this.getPatientInfo(pastedData);
            const insurance = this.getInsurance(pastedData);
            const info = this.getInfo(pastedData);
            callbackEmit({ parseData: Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), info) });
        }
        catch (error) {
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    getPatientInfo(data) {
        const nameMatch = data.match(/Patient Name\n([^\n]+)/);
        const rawName = nameMatch ? nameMatch[1].trim() : "";
        const nameParts = rawName.split(", ");
        const lastName = nameParts[0] ? nameParts[0].trim() : "";
        const firstName = nameParts[1] ? nameParts[1].trim() : "";
        const dobMatch = data.match(/Date of Birth:\s*(\d+\/\d+\/\d+)/);
        const dob = dobMatch ? (0, helper_1.getDOB)(dobMatch[1], true) : "";
        return {
            patientInfo: {
                firstName,
                lastName,
                phoneNo: this.extractPhone(data),
                address: this.extractAddress(data),
                dob,
            },
        };
    }
    extractPhone(data) {
        const phoneSectionMatch = data.match(/(Home:[\s\S]*?)Work:/);
        if (!phoneSectionMatch)
            return "";
        const section = phoneSectionMatch[1];
        const mobileMatch = section.match(/Mobile:\s*([\s\S]*?)(?=Work:|$)/);
        if (mobileMatch) {
            const mobileStr = mobileMatch[1].trim();
            const digits = mobileStr.replace(/[\s()-]/g, "");
            if (digits.length >= 10)
                return (0, helper_1.changeNumberUSFormat)(digits.substring(0, 10));
        }
        const homeMatch = section.match(/Home:\s*([\s\S]*?)(?=Mobile:|Work:|$)/);
        if (homeMatch) {
            const homeStr = homeMatch[1].trim();
            const digits = homeStr.replace(/[\s()-]/g, "");
            if (digits.length >= 10)
                return (0, helper_1.changeNumberUSFormat)(digits.substring(0, 10));
        }
        return "";
    }
    extractAddress(data) {
        const sectionMatch = data.match(/Patient’s Care Location Address and Telephone Number\n([\s\S]*?)\nHome:/);
        if (!sectionMatch)
            return { placeName: "", apartmentNo: "" };
        const lines = sectionMatch[1]
            .split("\n")
            .map(l => l.trim())
            .filter(l => l.length > 0);
        if (lines.length === 0)
            return { placeName: "", apartmentNo: "" };
        lines.shift();
        if (lines.length === 0)
            return { placeName: "", apartmentNo: "" };
        let cityState = lines.pop() || "";
        cityState = cityState.replace(/,\s*Ph:.*/, "").replace(/,$/, "").trim();
        const street = lines.join(" ").trim();
        const placeName = [street, cityState].filter(s => s).join(" ");
        return { placeName, apartmentNo: "" };
    }
    getInsurance(data) {
        const match = data.match(/Primary,\s*([^,\n]+),\s*([^,\n]+),/);
        return { insurance: match ? match[2].trim() : "" };
    }
    getInfo(data) {
        return {
            info: {
                physician: [this.extractPhysician(data)],
                pharmacy: [],
                careGiver: this.extractCareGiver(data),
            },
        };
    }
    extractPhysician(data) {
        const match = data.match(/Primary Physician:\s*([^\n]+)\nPh:\s*([^\n,]+)/);
        if (!match) {
            return { name: "", phoneNo: "", countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE, sortOrder: 1 };
        }
        const rawName = match[1].trim();
        const parts = rawName.split(", ");
        const lastName = parts[0] || "";
        const rest = parts[1] || "";
        const titleMatch = rest.match(/^(.*?)\s*\(([^)]+)\)$/);
        let firstName = rest;
        let title = "";
        if (titleMatch) {
            firstName = titleMatch[1].trim();
            title = titleMatch[2].trim();
        }
        const name = [firstName, lastName, title].filter(s => s).join(" ");
        const phoneRaw = match[2].trim();
        const digits = phoneRaw.replace(/[\s()-]/g, "");
        const phoneNo = digits.length >= 10 ? (0, helper_1.changeNumberUSFormat)(digits.substring(0, 10)) : "";
        return { name, phoneNo, countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE, sortOrder: 1 };
    }
    extractCareGiver(data) {
        const sectionMatch = data.match(/Emergency Contact Information:\n([\s\S]*?)Physician Contact Information:/);
        if (!sectionMatch)
            return [];
        const section = sectionMatch[1].trim();
        if (!section)
            return [];
        const lines = section
            .split("\n")
            .map(l => l.trim())
            .filter(l => l);
        if (!lines.length)
            return [];
        const name = lines[0];
        let phoneNo = "";
        const mobileMatch = section.match(/Mobile:\s*([\d() -]+)/);
        if (mobileMatch) {
            const digits = mobileMatch[1].trim().replace(/[\s()-]/g, "");
            if (digits.length >= 10)
                phoneNo = (0, helper_1.changeNumberUSFormat)(digits.substring(0, 10));
        }
        if (!phoneNo) {
            const homeMatch = section.match(/Home:\s*([\d() -]+)/);
            if (homeMatch) {
                const digits = homeMatch[1].trim().replace(/[\s()-]/g, "");
                if (digits.length >= 10)
                    phoneNo = (0, helper_1.changeNumberUSFormat)(digits.substring(0, 10));
            }
        }
        return [{ countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE, name, phoneNo, sortOrder: 1 }];
    }
}
exports.MatrixCare = MatrixCare;
